export default "__VITE_ASSET__Cn8klKpF__"